import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userInfo: null,
    permissions: [],
    isAuthenticated: false,
    role: null,
  },
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
      state.isAuthenticated = true;
      state.role = action.payload?.role || null;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    clearUser: (state) => {
      state.userInfo = null;
      state.permissions = [];
      state.isAuthenticated = false;
      state.role = null;
    },
  },
});

export const { setUserInfo, setPermissions, clearUser } = userSlice.actions;

export const selectUserInfo = (state) => state.user.userInfo;
export const selectIsAuthenticated = (state) => state.user.isAuthenticated;
export const selectPermissions = (state) => state.user.permissions;
export const selectRole = (state) => state.user.role;

export default userSlice.reducer;
